export function getLink(path?: string, baseUrl?: string) {
  if (!path || path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  if (!path.startsWith('/')) {
    path = '/' + path;
  }

  return (baseUrl || process.env.REACT_APP_API_URI || '') + path;
}
